import { useState, useEffect } from "react";
import "../../../scss/onboarding.scss";
import { connect } from "react-redux";
import { useSearchParams, useLocation } from "react-router-dom";

import Logo from "../../../assets/logo.png";
import RightImage from "../../../assets/landing/onboard-2.png";
import { allowNumbersOnly, getCredentials } from "../../../shared/utils";
import { authActions } from "../../../redux/actions/onboarding";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { authConstants } from "../../../redux/action-constants/onboarding.constants";
import { LoadingItem } from "../../../shared/components/loading";

const confirmAccountEmailAction = async ({ pageProps, action }: any) => {
  await pageProps.ConfirmAccountEmail(action);
}

const handleLogin = async ({ pageProps, payload }: any) => {

  await pageProps.LoginAction(payload);
}

const confirmPhonenumAction = async ({ pageProps, action }: any) => {
  await pageProps.ConfirmAccountPhone(action);
};
const VerificationContent = ({ pageProps }: any) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // const [searchParams] = useSearchParams();
  const handleUserInitialLogin = async () => {
    let { email, password } = getCredentials();
    let payload: any = {
      username: email,
      password,
      grant_type: "password",
      scope: "api1.read IdentityServerApi",
      client_secret: "SuperSecretPassword",
      client_id: "oauthClient"
    }
    var formBody: any = [];
    for (var property in payload) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(payload[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    await handleLogin({ pageProps, payload: formBody }).then(() => {
      localStorage.removeItem("user_credentials")
    })
  }


  useEffect(() => {
    handleLogin({
      pageProps,
      payload: "CLEAR"
    })
    confirmAccountEmailAction({
      pageProps,
      action: {
        email: params.get("email"),
        token: params.get("token"),
      },
    });
    // }
  }, []);
  // useEffect(() => {
  //   if (phoneOtpRequest) {
  //     if (
  //       pageProps?.confirmAccountPhoneRequest?.request_status &&
  //       pageProps.confirmAccountPhoneRequest.request_status !==
  //       "CONFIRM_PHONE_SUCCESS"
  //     ) {
  //       getOtpForConfirmPhoneAction({
  //         pageProps,
  //         action: `?email=${params.get("email")}`,
  //       });
  //       setPhoneOtpRequest(false);
  //     }
  //   }
  // }, [phoneOtpRequest]);
  return (
    <div className="email-verify-content">
      <div className="left-content">
        {pageProps?.confirmEmailRequest?.request_status !== authConstants.CONFIRM_EMAIL_PENDING
          && pageProps?.confirmEmailRequest?.request_status !== authConstants.CONFIRM_EMAIL_FAILURE ? (
          <div className="left-inner-content">
            <div className="text-content">
              <h3>Email address confirmed</h3>
              <p>Your email address is now confirmed.</p>
            </div>
            {pageProps?.loginRequest?.request_status === authConstants.LOGIN_USER_PENDING &&
              <LoadingItem />
            }
            {pageProps?.loginRequest?.request_status === authConstants.LOGIN_USER_FAILURE &&
              <AlertMsg type="error" message={pageProps?.loginRequest?.request_data?.error} />
            }
              <button onClick={handleUserInitialLogin} disabled={!getCredentials() || pageProps?.loginRequest?.request_status === authConstants.LOGIN_USER_PENDING }>
              Continue to your vendor dashboard
            </button>
          </div>
        ) :
          (
            pageProps?.confirmEmailRequest?.request_status === authConstants.CONFIRM_EMAIL_PENDING ? (
              <LoadingItem />
            ) : (
              <AlertMsg type="error" message={pageProps?.confirmEmailRequest?.request_data?.error} />
            )

          )}
      </div>

      <div className="right-content">
        <img src={RightImage} alt="Vendors" />
      </div>
    </div>

  );
};

const OnboardVerification = (pageProps: any) => {
  return (
    <div className="verify-wrap">
      <div className="verify-head">
        <div className="logo-head">
          <img src={Logo} alt="" />
        </div>
      </div>
      <VerificationContent pageProps={pageProps} />
      {/* <FooterWrap /> */}
    </div>
  );
};

const mapDispatchToProps = {
  ConfirmAccountEmail: authActions.ConfirmAccountEmail,
  GetOtpForVendorPhone: authActions.GetOtpForVendorPhone,
  ConfirmAccountPhone: authActions.ConfirmAccountPhone,
  logoutAction: authActions.Logout,
  LoginAction: authActions.Login,
};

const mapStateToProps = (state: any) => ({
  confirmEmailRequest: state.onboardingOutboundReducers.confirmEmailReducer,
  confirmAccountPhoneRequest:
    state.onboardingOutboundReducers.confirmAccountPhoneReducer,
  getOtpForVendorPhoneRequest:
    state.onboardingOutboundReducers.getOtpForVendorPhoneReducer,
  loginRequest: state.onboardingOutboundReducers.loginReducer,

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardVerification);
